<template>
    <div class="expandtofill pt-1">
        <div v-if="GET_docViewer.fileType === 'image/png' || GET_docViewer.fileType === 'image/jpeg'" class="expandtofill">
            <v-img height="95%"  contain :src="value" class="" />
        </div>
        <div v-else  class="expandtofill">
            <iframe :src="value" class="expandtofill" />
        </div>
        

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        // * COMPUTED
        data: () => ({
            category: 'ddd'
        }),
        computed: {
            ...mapGetters({
                GET_docViewer: 'docViewer_store/GET_docViewer'
            }),
            value() {
                // if (this.GET_docViewer.fileType === "application/octet-stream" || this.GET_docViewer.fileType === "application/vnd.ms-excel") {
                //     var url = "https://view.officeapps.live.com/op/embed.aspx?src=" + this.GET_docViewer.fileURL + '100%'
                //     return (url)
                console.log('this.GET_docViewer = ', JSON.stringify(this.GET_docViewer, null, 2))
                if (this.GET_docViewer.fileType === "application/pdf") {
                    return (this.GET_docViewer.fileURL);
                } else if (this.GET_docViewer.fileType ==="video/mpeg") {
                    return this.GET_docViewer.fileURL;
                } else if (this.GET_docViewer.fileType ==="video/mpeg") {
                    return this.GET_docViewer.fileURL;
                } else if
                    (
                        (this.GET_docViewer.fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                        || (this.GET_docViewer.fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                        || (this.GET_docViewer.fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation')
                        // TODO NEED TO ADD MORE OFFICE FILE TYPES HERE e.g doc not docx                    
                    ) {
                        // console.log('office doc ')
                        this.category = 'office';
                        var url = "https://view.officeapps.live.com/op/embed.aspx?src=" + this.GET_docViewer.fileURL + '100%'
                        return (url)
                } else {
                    return this.GET_docViewer.fileURL;
                }
            },
        }
    }
</script>

<style scoped>
    .expandtofill {
        display: block !important; width: 100% !important; height: 100% !important;
        /* background: #ffffff !important; */
    }
</style>